export const SET_PRODUCTS = "SET_PRODUCTS";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_ALL_PRODUCTS = "DELETE_ALL_PRODUCTS";
